import { store } from 'store';

export const isEncryptionEnabled = (): boolean => {
  const state = store.getState();
  return state.main.login.settings?.SYSTEM_AES_EncryptionAtRest === true;
};

export const getEncryptedColumnProps = () => (isEncryptionEnabled() ? { sortable: false as const } : {});
